import { NgModule } from "@angular/core";
import { FilterPipe } from "./pipe/filter/filter.pipe";
import { ObsCardWalletComponent } from "./components/obs-card-wallet/obs-card-wallet.component";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { HttpLoaderFactory } from "../app.module";
import { HttpClient } from "@angular/common/http";
import { ObsButtonComponent } from "./components/obs-button/obs-button.component";
import { ObsButtonMultipleComponent } from "./components/obs-button-multiple/obs-button-multiple.component";
import { CommonModule } from "@angular/common";
import { ObsSelectComponent } from "./components/obs-select/obs-select.component";
import { ObsCurrencyComponent } from "./components/obs-currency/obs-currency.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ObsLoadingComponent } from "./components/obs-loading/obs-loading.component";
import { FormatTimePipe } from "./pipe/formatTime.pipe";
import { ObsAuthyComponent } from "./components/obs-authy/obs-authy.component";
import { CurrencyMaskModule } from "ng2-currency-mask";
import { IMaskModule } from "angular-imask";
import { ObsTermsConditionsComponent } from "./components/obs-terms-conditions/obs-terms-conditions.component";
import { ObsCircleProgressComponent } from "./components/obs-circle-progress/obs-circle-progress.component";
import { ObsCardWalletBbComponent } from "./components/obs-card-wallet-bb/obs-card-wallet-bb.component";
import { ObsCreateNewAccountComponent } from './components/obs-create-new-account/obs-create-new-account.component';
import {ObsWalletBoxComponent} from './components/obs-wallet-box/obs-wallet-box.component'
import {OrderDescriptionComponent} from './components/order-description/order-description.component'
import {BankDetailUIComponent} from './components/bank-detail-ui/bank-detail-ui.component'
import {CountoModule} from 'angular2-counto';
import { ObsSelectItemDisabledComponent } from "./components/obs-select-item-disabled/obs-select-item-disabled.component";
import { ObsCurrencyV2Component } from "./components/obs-currency-v2/obs-currency-v2.component";
import { ObsTopPortfolioComponent } from './components/obs-top-portfolio/obs-top-portfolio.component'
import { HighchartsChartModule } from 'highcharts-angular';
import { ModalPrivateTakeOrderComponent } from "./components/modal-private-take-order/modal-private-take-order.component";
import { ObsCardWalletDidiComponent } from "./components/obs-card-wallet-didi/obs-card-wallet-didi.component";
import { ObsAuthy2Component } from "./components/obs-authy-2/obs-authy-2.component";
@NgModule({
  declarations: [
    FilterPipe,
    FormatTimePipe,
    ObsCardWalletComponent,
    ObsCardWalletBbComponent,
    ObsCardWalletDidiComponent,
    ObsButtonComponent,
    ObsButtonMultipleComponent,
    ObsSelectComponent,
    ObsSelectItemDisabledComponent,
    ObsCurrencyComponent,
    ObsCurrencyV2Component,
    ObsLoadingComponent,
    ObsAuthyComponent,
    ObsAuthy2Component,
    ObsTermsConditionsComponent,
    ObsCircleProgressComponent,
    ObsCreateNewAccountComponent,
    ObsWalletBoxComponent,
    OrderDescriptionComponent,
    BankDetailUIComponent,
    ObsTopPortfolioComponent,
    ModalPrivateTakeOrderComponent
  ],
  imports: [
    CurrencyMaskModule,
    IMaskModule,
    CountoModule,
    HighchartsChartModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    CommonModule,
    FormsModule,
    ReactiveFormsModule,

  ],
  exports: [
    FilterPipe,
    ObsCardWalletComponent,
    ObsCardWalletBbComponent,
    ObsCardWalletDidiComponent,
    ObsButtonComponent,
    ObsButtonMultipleComponent,
    ObsCurrencyComponent,
    ObsSelectItemDisabledComponent,
    ObsCurrencyV2Component,
    ObsSelectComponent,
    ObsLoadingComponent,
    FormatTimePipe,
    ObsAuthyComponent,
    ObsAuthy2Component,
    IMaskModule,
    ObsTermsConditionsComponent,
    ObsCircleProgressComponent,
    ObsCreateNewAccountComponent,
    ObsWalletBoxComponent,
    OrderDescriptionComponent,
    BankDetailUIComponent,
    ObsTopPortfolioComponent,
    ModalPrivateTakeOrderComponent
  ],
})
export class SharedModule { }
